// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountTosAcceptanceArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountTosAcceptanceArkFragment on OpenapiAccountTosAcceptance {
    date
    iovation_blackbox
    ip
    service_agreement
    user_agent
  }
`;

export const stripeAccountTosAcceptanceArkFragment: StripeAccountTosAcceptanceArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountTosAcceptanceArkFragmentData = {
  readonly __typename: 'OpenapiAccountTosAcceptance';
  readonly date: number | null;
  readonly iovation_blackbox: string | null;
  readonly ip: string | null;
  readonly service_agreement: string | null;
  readonly user_agent: string | null;
};

export type StripeAccountTosAcceptanceArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountTosAcceptanceArkFragmentPermissions = {} as const;

doc.permissions = stripeAccountTosAcceptanceArkFragmentPermissions;

export type StripeAccountTosAcceptanceArkFragmentPermissions =
  V1PermissionToken<typeof stripeAccountTosAcceptanceArkFragmentPermissions>;

export type StripeAccountTosAcceptanceArkFragmentDocument = GraphQlDocument<
  StripeAccountTosAcceptanceArkFragmentData,
  StripeAccountTosAcceptanceArkFragmentVariables,
  StripeAccountTosAcceptanceArkFragmentPermissions
>;
